import { Redirect, Route, Switch } from "react-router";
import React from "react";

// Other Routes
import UserManagementPage from "./components/UserManagement/UserManagementPage";
import BillingPage from "./components/Billing/BillingPage";
import { gated } from "./components/FeatureGate/FeatureGate";
import AppointmentType from "./components/appointmentTypes/AppointmentType";
import PatientBoardMain from "./components/patientBoard/PatientBoardMain";
import ProviderScheduling from "./components/ProviderScheduling";
import Appointment from "./components/appointment/Appointment";
import AddProvider from "./components/addProvider/AddProvider";
import Transaction from "./components/Transaction/Transaction";
import PlanManagement from "./components/Plan/PlanManagement";
import AddAccount from "./components/addAccount/AddAccount";
import DiscountOptions from "./components/DiscountOptions";
import Finanace from "./components/FinanceFlow/Finanace";
import Analytics from "./components/analytics/Analytics";
import UploadPdfPage from "./components/UploadPdfPage";
import Checkout from "./components/checkOut/Checkout";
import Service from "./components/Service/Service";
import routes from "./constants/routes";
import App from "./containers/App";

// Booking
import BookingStepThree from "./components/booking/BookingStepThree";
import BookingHandler from "./components/booking/BookingHandler";
import BookingStepOne from "./components/booking/BookingStepOne";
import BookingStepTwo from "./components/booking/BookingStepTwo";
import BookingSummary from "./components/booking/BookingSummary";

// Auth
import CompleteRegistrationPage from "./components/auth/CompleteRegistrationPage";
import ResetConfirm from "./components/auth/ResetConfirm";
import Login from "./components/auth/Login";

// Payment
import PaymentWizardHandler from "./components/Payment/PaymentWizardHandler";
import SelectPaymentMethod from "./components/Payment/SelectPaymentMethod";
import PaymentRequestPage from "./components/Payment/PaymentRequestPage";
import PaymentWizardStep2 from "./components/Payment/PaymentWizardStep2";
import DashboardPage from "./components/dashboardPayment/DashboardPage";
import DoneWizardPayment from "./components/Payment/DoneWizardPayment";
// import PaymentFirstPage from "./components/Payment/PaymentFirstPage";
import PaymentDoneMulti from "./components/Payment/PaymentDoneMulti";
import FailedPayments from "./components/Payment/FailedPayments";
import EmailPayment from "./components/Payment/EmailPayment";
import PaymentDone from "./components/Payment/PaymentDone";
import Payment from "./components/Payment/Payment";

// Error
import Error404 from "./Error404";
import Error500 from "./Error500";

// AR
import ArDetail from "./components/Ar/ArDetail";
import Ar from "./components/Ar/Ar";

// New
import TreatmentPlan from "./New/Treatment Plan/TreatmentPlan";
import HomeNew from "./New/HomeNew";
import Oral from "./New/Oral/Oral";

// Office
import Review from "./components/Office/Review";
import Profile from "./components/Office/Profile";
import PortalCredentialsPanel from "./components/Office/PortalCredentials/PortalCredentialsPanel";
import OfficeProviders from "./components/OfficeProviders/OfficeProviders";
import EditProvider from "./components/OfficeProviders/EditProvider";
import InsuranceCarrierCallAdmin from "./components/InsuranceCarrierCallAdmin/InsuranceCarrierCallAdmin";

// Membership
import CreateOfficeDashboard from "./components/Membership/CreateOfficeDashboard";
import Subscriptions from "./components/Membership/Subscriptions";
import PlansDetail from "./components/Membership/PlansDetail";
import Dashboard from "./components/Membership/Dashboard";
import Members from "./components/Membership/Members";
import Visit from "./components/Membership/Visit";
import Plans from "./components/Membership/Plans";

// Home
import ClinicProfile from "./Home/ClinicProfile";
import LandingPage from "./Home/LandingPage";
import SetReview from "./Home/SetReview";
import Provider from "./Home/Provider";
import Home from "./Home/Home";

// Data
import HealthCategories from "./components/Data/HealthCategories";
import Procedures from "./components/Data/Procedures";

import Helcim from "./Helcim";

// Login
import { controller } from "./Login/controller";
import LoginPage from "./Login/LoginPage";

// Treatment Plans
import TreatmentPlans from "../src/components/TreatmentPlans/TreatmentPlans";
import Preview from "./components/TreatmentPlans/component/Preview";

// Marketing
import CreateCampaigns from "./components/Marketing/CreateCampaigns";
import Campaigns from "../src/components/Marketing/Campaigns";

// Insurance
import InsuranceBreakDown from "./components/InsuranceBreakDown/InsuranceBreakDown";
import Insurance from "./components/Insurance/Insurance";
import TreatmentPlansAccountReceivable from "./components/TreatmentPlans/TreatmentPlansAccountReceivable";
import FTCTasksPage from "./components/FTCTasks/FTCTasksPage";
import FtcInboxPage from "./components/FTCTasks/FtcInboxPage";
import FtcReportsPage from "./components/FTCTasks/FtcReportsPage";
import InsuranceLinkPage from "./components/DeepLink/InsuranceLinkPage";
import LinkSignInRedirect from "./components/DeepLink/LinkSignInRedirect";
import InsuranceRequestsPage from "./components/InsuranceRequests/InsuranceRequestsPage";
import CrmPage from "./components/CRM/CrmPage";
import CrmSettingsPage from "./components/CRM/CrmSettingsPage";
import CrmAnalyticsPage from "./components/CRM/CrmAnalyticsPage";
import FtcUsersPage from "./components/CRM/FtcUsersPage";
import CarrierKnowledgePage from "./components/CRM/CarrierKnowledgePage";
import PredeterminationRulesAdmin from "./components/PredeterminationRulesAdmin/PredeterminationRulesAdmin";
import TargetsAndRewards from "./components/TargetsAndRewards/TargetsAndRewards";
import Submit2FAPage from "./components/TwoFA/Submit2FAPage";
import BreakdownWorksheetPage from "./components/BreakdownWorksheet/BreakdownWorksheetPage";

// Pages a super admin can switch off per office (CRM office drawer → Features),
// and the Payments & AR pages that lock without a bank account. See
// components/FeatureGate. The patient-facing payment routes are NOT gated.
const GatedTreatmentPlans = gated("treatment_planning", TreatmentPlans);
const GatedFailedPayments = gated("payments_ar", FailedPayments);
const GatedArDetail = gated("payments_ar", ArDetail);
const GatedAr = gated("payments_ar", Ar);
const GatedTransaction = gated("payments_ar", Transaction);
const GatedPaymentRequests = gated("payments_ar", DashboardPage);
const GatedPaymentRequestPage = gated("payments_ar", PaymentRequestPage);
const GatedPatientBoard = gated("automation_engine", PatientBoardMain);
const GatedTargetsAndRewards = gated("targets_rewards", TargetsAndRewards);


export default class AppParent extends React.Component {
  checkOnboarding = async () => {
    if (localStorage.getItem("onBoardingStep") === "completed") {
      this.setState({
        onBoardingCompleted: "true",
      });
    } else if (localStorage.getItem("user")) {
      const response = await controller.getOnboardingSteps();
      const onboarding_name =
        response.result && response.result.length === 0
          ? "completed"
          : response.result && response.result[0] && response.result[0].onboarding_step_name;

      if (onboarding_name === "completed") {
        localStorage.setItem("onBoardingStep", "completed");
        this.setState({
          onBoardingCompleted: "true",
        });
      } else {
        this.setState({
          onBoardingCompleted: "false",
        });
      }
    } else {
      this.setState({
        onBoardingCompleted: "false",
      });
    }
  };

  async componentDidMount() {
    await this.checkOnboarding();
  }

  constructor(props) {
    super(props);
    this.state = {
      onBoardingCompleted: "loading",
    };
  }
  render() {
    // const { store, history } = this.props;

    return (
      <App>
        {localStorage.getItem("user") ? (
          this.state.onBoardingCompleted === "loading" ? (
            <></>
          ) : this.state.onBoardingCompleted === "true" ? (
            <Switch>
              {/* Opened from the 2FA email/SMS. Registered in BOTH switches: the
                  recipient may already be signed in on their phone, and the page
                  needs no auth either way. */}
              <Route path={"/2fa/:token"} component={Submit2FAPage} />
              <Route path={"/test-helcim"} component={Helcim} />
              <Route path={routes.ORAL} component={Oral} />
              <Route path={routes.TREATMENTPLAN} component={TreatmentPlan} />
              <Route path={routes.TREATMENTPLANS_ACCOUNTRECEIVABLE} component={TreatmentPlansAccountReceivable} />
              <Route path={routes.TreatmentPlans} component={GatedTreatmentPlans} />
              <Route path={routes.FTC_TASKS} component={FTCTasksPage} />
              <Route path={routes.FTC_INBOX} component={FtcInboxPage} />
              <Route path={routes.FTC_REPORTS} component={FtcReportsPage} />
              {/* Emailed deep link. Registered in BOTH switches: logged in it
                  opens the record, logged out it bounces via sign-in and comes
                  back. The URL itself grants nothing — see InsuranceLinkPage. */}
              <Route path={routes.LINK_INSURANCE} component={InsuranceLinkPage} />
              <Route path={routes.INSURANCE_REQUESTS} component={InsuranceRequestsPage} />
              {/* Static mock, reachable by URL only — no menu entry. */}
              <Route path={routes.BREAKDOWN_WORKSHEET} component={BreakdownWorksheetPage} />
              {/* These are non-exact routes in a Switch, so the more specific
                  /crm-* paths must stay ABOVE routes.CRM or "/crm" swallows them. */}
              {/* Requests now lives as a tab on Carrier Knowledge. The old
                  route is kept as a redirect so bookmarks still land. */}
              <Route path={routes.CRM_REQUESTS} render={() => <Redirect to={routes.CARRIER_KNOWLEDGE} />} />
              <Route path={routes.CRM_SETTINGS} component={CrmSettingsPage} />
              <Route path={routes.CRM_ANALYTICS} component={CrmAnalyticsPage} />
              <Route path={routes.FTC_USERS} component={FtcUsersPage} />
              <Route path={routes.CARRIER_KNOWLEDGE} component={CarrierKnowledgePage} />
              <Route path={routes.CRM} component={CrmPage} />
              <Route path={routes.PREDETERMINATION_RULES} component={PredeterminationRulesAdmin} />
              <Route path={routes.ANALYTICS} component={Analytics} />
              <Route path={routes.Preview} component={Preview} />
              <Route path={routes.Campaigns} component={Campaigns} />
              <Route path={routes.CreateCampaigns} component={CreateCampaigns} />
              <Route path={routes.NEWHOME} component={HomeNew} />
              <Route path={routes.PROCEDURES} component={Procedures} />
              <Route path={routes.HEALTHCATEGORY} component={HealthCategories} />
              <Route path={routes.APPOINTMENTTYPE} component={AppointmentType} />
              <Route path={routes.DISCOUNTOPTIONS} component={DiscountOptions} />
              <Route path={routes.PLANMANAGEMENT} component={PlanManagement} />
              <Route path={routes.SERVICEMANAGEMENT} component={Service} />
              <Route path={routes.FAILEDPAYMENTS} component={GatedFailedPayments} />
              <Route path={routes.BOOKINGMAIN} component={BookingHandler} />
              <Route path={routes.CREATEOFFICE} component={CreateOfficeDashboard} />
              <Route path={routes.CREATEOFFICE} component={CreateOfficeDashboard} />
              <Route path={routes.MEMBERS} component={Members} />
              <Route path={routes.PROFILE} component={Profile} />
              <Route path={routes.OFFICE_PORTAL_CREDENTIALS} component={PortalCredentialsPanel} />
              <Route path={routes.EDIT_PROVIDER} component={EditProvider} />
              <Route path={routes.OFFICE_PROVIDERS} exact component={OfficeProviders} />
              {/* The carrier admin page folded into Carrier Knowledge, which now
                  holds the same record, procedure codes and capability matrix
                  alongside the playbooks. Kept as a redirect because the path is
                  bookmarked. */}
              <Route
                path={routes.OFFICE_INSURANCE_CARRIERS}
                exact
                render={function () { return <Redirect to={routes.CARRIER_KNOWLEDGE} />; }}
              />
              <Route path={routes.REVIEW} component={Review} />
              <Route path={routes.SUBSCRIPTIONS} component={Subscriptions} />
              <Route path={routes.PLANS} component={Plans} />
              <Route path={routes.PLANDETAIL} component={PlansDetail} />
              <Route path={routes.VISIT} component={Visit} />
              <Route path={routes.DASHBOARD} component={Dashboard} />
              <Route path={routes.ARDETAIL} component={GatedArDetail} />
              <Route path={routes.AR} component={GatedAr} />
              <Route path={routes.TRAMSACTIONS} component={GatedTransaction} />
              <Route path={routes.OFFICES} component={UserManagementPage} />
              <Route path={routes.BILLING} component={BillingPage} />
              <Route path={routes.FINANACE} component={Finanace} />
              <Route path={routes.ACCOUNTSRECEIVABLE} component={GatedPaymentRequests} />
              <Route path={routes.APPOINTMENTS} component={Appointment} />
              <Route path={routes.PAYMENTDONE} component={PaymentDone} />
              <Route path={routes.PAYMENTDONEMULTI} component={PaymentDoneMulti} />
              <Route path={routes.PAYMENTFLOW} component={SelectPaymentMethod} />
              <Route path={routes.PAYMENT} component={EmailPayment} />
              <Route path={routes.SINGLEPAYMENT} component={Payment} />
              <Route path={routes.PAYMENTWIZARD} component={(routeProps, props) => <PaymentWizardHandler {...routeProps} {...props} />} />
              <Route path={routes.UPLOADPDF} component={UploadPdfPage} />
              <Route path={routes.PROVIDERSCHEDULING} component={ProviderScheduling} />
              <Route path={routes.ERRORNOTFOUND} component={Error404} />
              <Route path={routes.ERRORSERVER} component={Error500} />
              <Route path={routes.ADD_PROVIDER} component={AddProvider} />
              <Route path={routes.ADDACCOUNT} component={AddAccount} />
              <Route path={routes.CHECKOUT} component={Checkout} />
              <Route path={routes.RESETCONFIRM} component={ResetConfirm} />
              <Route path={routes.PASSWORD} component={CompleteRegistrationPage} />
              <Route path={routes.PAYMENTREQUEST} component={GatedPaymentRequestPage} />
              <Route path={routes.INSURANCE} component={Insurance} />
              <Route path={routes.INSURANCEBREADDOWN} component={InsuranceBreakDown} />
              <Route path={routes.PATIENTBOARD} component={GatedPatientBoard} />
              <Route path={routes.TARGETS_AWARDS} component={GatedTargetsAndRewards} />
              <Route path={routes.CARRIER_CALL_ADMIN} component={InsuranceCarrierCallAdmin} />

              <Route path={routes.LOGOUT} component={Login} />
              <Route path={routes.LOGINPAGE} component={Login} />
              <Route path={routes.LOGIN} component={Login} />

              <Route path={routes.BOOKINGSTEPONE} component={BookingStepOne} />
              <Route path={routes.BOOKINGSTEPTWO} component={BookingStepTwo} />
              <Route path={routes.BOOKINGSTEPTHREE} component={BookingStepThree} />
              <Route path={routes.BOOKINGSUMMARY} component={BookingSummary} />

            </Switch>
          ) : (
            <LoginPage />
          )
        ) : (
          <Switch>
            <Route path={routes.TREATMENTPLAN} component={TreatmentPlan} />
            <Route path={routes.NEWHOME} component={HomeNew} />
            <Route path={"/2fa/:token"} component={Submit2FAPage} />
            <Route path={"/test-helcim"} component={Helcim} />
            <Route path={routes.PROVIDER} component={Provider} />
            <Route path={routes.SETREVIEW} component={SetReview} />
            <Route path={routes.HOMEPAGE} component={LandingPage} />
            <Route path={routes.SEARCHRESULT} component={Home} />
            <Route path={routes.CLINICPROFILE} component={ClinicProfile} />
            <Route path={routes.FINANACE} component={Finanace} />
            <Route path={routes.BOOKINGMAIN} component={BookingHandler} />
            <Route path={routes.ERRORNOTFOUND} component={Error404} />
            <Route path={routes.ERRORSERVER} component={Error500} />
            <Route path={routes.PAYMENTFLOW} component={SelectPaymentMethod} />
            <Route path={routes.PAYMENT} component={EmailPayment} />
            <Route path={routes.SINGLEPAYMENT} component={Payment} />
            <Route path={routes.PAYMENTWIZARD} component={(routeProps, props) => <PaymentWizardHandler {...routeProps} {...props} />} />
            <Route path={routes.PAYMENTWIZARDSTEP2} component={PaymentWizardStep2} />
            <Route path={"/main-handle/:uuid"} component={PaymentWizardHandler} />
            <Route path={routes.PAYMENTWIZARDSTEPDONE} component={DoneWizardPayment} />
            <Route path={routes.PAYMENTDONE} component={PaymentDone} />
            <Route path={routes.PAYMENTDONEMULTI} component={PaymentDoneMulti} />
            <Route path={routes.RESETCONFIRM} component={LoginPage} />
            {/* <Route path={routes.RESETCONFIRM} component={ResetConfirm} /> */}
            <Route path={routes.PASSWORD} component={CompleteRegistrationPage} />
            <Route path={routes.LOGOUT} component={LoginPage} />
            <Route path={routes.LOGINPAGE} component={LoginPage} />
            <Route path={routes.LOGIN} component={LoginPage} />
            <Route path={routes.LINK_INSURANCE} component={LinkSignInRedirect} />
            <Route path={routes.LOGINNEW} component={LoginPage} />
          </Switch>
        )}
      </App>
    );
  }
}
